import React, { useEffect, useState } from 'react'
import './Stories.css'

import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/splide.min.css'
import StoryModal from './StoryModal'
import Header from '../../layout/Header/Header'
import UpdatesCard from './UpdatesCard'

function Stories() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const splideOptions = {
    perPage: 16,
    rewind: true,
    gap: '0rem',
    type: 'slide',
    padding: 16,
    arrows: false,
    pagination: false,
    breakpoints: {
      500: {
        perPage: 4
      },
      768: {
        perPage: 7
      },
      1200: {
        perPage: 11
      }
    }
  }

  const [isOpen, setIsOpen] = useState(false)
  const [activeStory, setActiveStory] = useState(null)

  const storiesData = [
    {
      id: 1,
      username: 'Sophie Asveld',
      timeAgo: '5 minutes ago',
      avatar: 'assets/img/sample/avatar/avatar2.jpg',
      image: 'assets/img/sample/photo/vertical2.jpg',
      caption: 'Beautiful day!',
      duration: 5000 // 5 seconds
    },
    {
      id: 2,
      username: 'Aditya',
      timeAgo: '5 minutes ago',
      avatar: 'assets/img/sample/avatar/avatar2.jpg',
      image: 'assets/img/avatar1.jpg',
      caption: 'Beautiful day!',
      duration: 5000 // 5 seconds
    },
    {
      id: 3,
      username: 'Asveld',
      timeAgo: '5 minutes ago',
      avatar: 'assets/img/sample/avatar/avatar2.jpg',
      image: 'assets/img/sample/photo/vertical2.jpg',
      caption: 'Beautiful day!',
      duration: 5000 // 5 seconds
    }
    // Add more stories as needed
  ]

  const handleStoryOpen = story => {
    setActiveStory(story)
    setIsOpen(true)
  }

  const handleStoryClose = e => {
    e.preventDefault()
    setIsOpen(false)
    setActiveStory(null)
  }

  const storyItems = [
    { id: 1, imgSrc: 'assets/img/avatar1.jpg' },
    { id: 2, imgSrc: 'assets/img/avatar1.jpg' },
    { id: 3, imgSrc: 'assets/img/avatar1.jpg' }
    // Add more items as needed
  ]

  return (
    <>
      <Header />
      <div
        className="content my-5 d-flex justify-content-center"
        style={{
          height: 'calc(100dvh - (var(--header-height) * 2) - 2px)',
          overflowY: 'auto'
        }}
      >
        {/* <UpdatesCard />
        <UpdatesCard />
        <UpdatesCard />
        <UpdatesCard />
        <UpdatesCard /> */}
        <h2 className="soon mt-5">
          <i>Coming Soon</i>
        </h2>
      </div>
    </>
  )
}

export default Stories
